import styled from 'styled-components';
import { Steps } from 'antd';

export const AIGenerationSteps = styled(Steps)`
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
    background-color: transparent !important;
  }
  .anticon {
    margin-right: 5px;
  }
  .failedStep {
    color: #ff0000;
  }
  .processing {
    color: rgba(0, 0, 0, 0.65) !important;
  }
  .waitOrFinish {
    color: rgba(0, 0, 0, 0.45) !important;
  }
  .ant-steps-item.ant-steps-item-custom {
    width: 20% !important;
    height: 250px !important;
  }
  .ant-steps-item-title::after {
    position: absolute;
    top: 100px;
    right: 0;
  }
  .ant-steps-item-title::after {
    display: none;
  }
  .ant-steps-item-container {
    outline: none;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-steps-item-description {
    color: rgba(0,0,0,0.45);
    position: absolute;
    bottom: 0;
    right: 0;
    max-width: 100% !important;
    width: 100%;
    text-align: center;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 600;
  }
  .ant-steps-item-custom .ant-steps-item-icon {
    width: 200px !important;
    height: 200px !important;
    margin: 0;
  }
`;

export const DividerLine = styled.div`
  width: 150px;
  display: flex;
  align-items: center;
  p {
    border-top: ${props => (props.finish ? '5px dotted #ff0000' : '5px dotted #bebebe')};
    width: 200px;
  }
`;

export const AppTourTooltip = styled.div`
  background: #000;
  font-family: 'Open Sans', sans-serif;
  padding: 24px;
  color: #fff;
  text-align: center;
  border-radius: 32px;
  width: 350px;
  ${props =>
    props.welcomeTooltip &&
    `
    padding: 50px;
    width: 1100px;
  `}
  ${props =>
    props.customTooltip &&
    `
    margin-right: -50px;
    background: transparent;
    font-weight: 700;
    color: #fff;
    font-family: 'Lacquer', system-ui;
    text-transform: lowercase;
    padding: 0;
    width: auto;
  `}
  @media (max-width: 1100px) {
    ${props =>
      props.welcomeTooltip &&
        `
          padding: 25px;
          width: 850px;
        `
    }
  }
  @media (max-width: 800px) {
    ${props =>
      props.welcomeTooltip &&
        `
          padding: 25px;
          width: 500px;
        `
    }
  }
`;

export const WelcomeTooltip = styled.div`
  display: flex;
  align-items: center;
  .column {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-inline: 12px;
    gap: 32px;
    h3 {
      color: #fff;
      font-weight: 700;
    }
    div {
      display: flex;
      gap: 32px;
    }
    :last-child {
      padding-inline: 36px;
    }
  }
  p {
    font-size: 17px;
  }
  @media (max-width: 1100px) {
    .column {
      gap: 24px;
      iframe {
        width: 325px;
      }
      div {
        gap: 32px;
      }
      :last-child {
        padding-inline: 16px;
      }
    }
  }
  @media (max-width: 800px) {
    flex-wrap: wrap;
    flex-direction: column;
  }
`;
export const CloseButton = styled.div`
  font-size: 32px;
  cursor: pointer;
  position: absolute;
  top: 8px;
  right: 28px;
  :hover {
    transform: scale(1.1);
    transition: all 0.2s ease;
  }
`;

export const VerticalLine = styled.div`
  background: #9cf7fa;
  height: 58px;
  width: 5px;
  margin-inline: 50px;
  @media (max-width: 1100px) {
    width: 3px;
    margin-inline: 25px;
  }
  @media (max-width: 800px) {
    height: 2px;
    width: 80px;
    margin-block: 25px;
  }
`;

export const TourButton = styled.button`
  background: #d9d9d9;
  color: #000;
  text-transform: uppercase;
  font-family: 'Open Sans', sans-serif !important;
  border: 0;
  font-weight: 700;
  padding: 8px;
  border-radius: 8px;
  min-width: 86px;
  cursor: pointer;
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  :hover:not(:disabled) {
    transform: scale(1.05);
    transition: all .2s ease;
  }

  ${props =>
    props.skip &&
    `
      background: #8C52FF;
      color: #fff;
    `}

  ${props =>
    props.next &&
    `
      background: #FFDE59;
    `}
`;

export const ArrowTooltip = styled.div`
  display: flex;
  align-items: center;
  font-size: 19px;
  div {
    width: 118px;
  }
`;

export const Content = styled.div`
  font-family: 'Lacquer', system-ui;
  text-transform: lowercase;
  padding: 0px 16px 16px;
  font-size: 18px;

  svg {
    display: block;
    margin-inline: auto;
    padding-top: 32px;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  gap: 18px;
`;